import React, { useState, useEffect } from "react";
import { useAuth } from "./AuthProvider";
import AccessDenied from "./AccessDenied";
import axios from "axios";

const AccessControl = ({ 
  children, 
  requiredModule, // 'map' or 'calls'
  fallbackComponent = null 
}) => {
  const { user } = useAuth();
  const [userPlan, setUserPlan] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        // Get user's plan from the server
        const response = await axios.get('/api/isLoggedIn');
        if (response.data && response.data.plan) {
          setUserPlan(response.data.plan);
          
          // Check if user has access to the required module
          let hasModuleAccess = false;
          
          if (requiredModule === 'map') {
            // Plan 1 (Map only) or Plan 3 (Both) have map access
            hasModuleAccess = response.data.plan === 1 || response.data.plan === 3;
          } else if (requiredModule === 'calls') {
            // Plan 2 (Call only) or Plan 3 (Both) have calls access
            hasModuleAccess = response.data.plan === 2 || response.data.plan === 3;
          }
          
          setHasAccess(hasModuleAccess);
        } else {
          setHasAccess(false);
        }
      } catch (error) {
        console.error("Error checking access:", error);
        setHasAccess(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAccess();
  }, [requiredModule]);

  if (isLoading) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        height: "100vh",
        backgroundColor: "#f5f5f5"
      }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ 
            width: "50px", 
            height: "50px", 
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #3498db",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 20px"
          }}></div>
          <p style={{ color: "#666" }}>Checking access permissions...</p>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!hasAccess) {
    const moduleName = requiredModule === 'map' ? 'Map System' : 'Call Module';
    
    if (fallbackComponent) {
      return fallbackComponent;
    }
    
    return <AccessDenied moduleName={moduleName} />;
  }

  return children;
};

export default AccessControl; 